export const experienceStint = [
  {
    value: "less_than_3_months",
    text: "3ヶ月未満"
  },
  {
    value: "less_than_6_months",
    text: "6ヶ月未満"
  },
  { value: "less_than_3_years", text: "1~3年未満" },
  { value: "less_than_5_years", text: "3~5年未満" },
  { value: "less_than_10_years", text: "5~10年未満" },
  { value: "greater_than_or_equal_10_years", text: "10年以上" }
];
